import { setupAGGrid } from "@/lib/AGGrid/setupAGGrid";
import { BookingListItem } from "@/app/Bookings/GraphQL/bookingListQuery";
import { useNavigate, useSearch } from "@tanstack/react-router";

setupAGGrid();
import { Suspense, useCallback, useRef } from "react";
import { Button } from "@/components/catalyst/button";
import { DateRangePicker } from "@/components/ui/date-range/date-range-picker";
import dayjs from "dayjs";
import { AgGridReact } from "ag-grid-react";
import { Skeleton } from "@/components/ui/skeleton";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { SupplierReportTable } from "@/app/Reports/SupplierReport/Components/SupplierReportTable";

function SupplierReportScreen() {
  const gridRef = useRef<AgGridReact<BookingListItem>>(null);

  const { startDate, endDate } = useSearch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/reports/suppliers",
  });

  const navigate = useNavigate({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/reports/suppliers",
  });

  const onBtExport = useCallback((type: "csv" | "xls") => {
    const onlySelected = gridRef.current?.api.getSelectedRows().length !== 0;

    if (type === "csv") {
      gridRef.current!.api.exportDataAsCsv({
        onlySelected,
      });
    } else {
      gridRef.current!.api.exportDataAsExcel({
        onlySelected,
      });
    }
  }, []);

  return (
    <div className="flex h-full flex-col space-y-3 p-6">
      <div className="flex w-full flex-wrap items-end justify-between gap-4 rounded-lg p-3">
        <div>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink
                  from="/$tenant/$orgId/supplier/{-$supplierId}"
                  to="/$tenant/$orgId/supplier/{-$supplierId}/reports"
                  params={(prev) => prev}
                >
                  Reporting
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Suppliers</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
        <div className="flex gap-4">
          <DateRangePicker
            align="end"
            disableFutureDates
            initialDateFrom={dayjs(startDate).toDate()}
            initialDateTo={dayjs(endDate).toDate()}
            onUpdate={({ range }) => {
              navigate({
                params: (prev) => prev,
                search: (old) => {
                  return {
                    ...old,
                    startDate: dayjs(range.from).format("YYYY-MM-DD"),
                    endDate: dayjs(range.to).format("YYYY-MM-DD"),
                  };
                },
              });
            }}
          />
          <Button outline onClick={() => onBtExport("csv")}>
            Export csv
          </Button>
          <Button onClick={() => onBtExport("xls")}>Export excel</Button>
        </div>
      </div>

      <div className="grow rounded-lg">
        <Suspense fallback={<Skeleton className="mt-3 h-80" />}>
          <SupplierReportTable ref={gridRef} />
        </Suspense>
      </div>
    </div>
  );
}

export default SupplierReportScreen;
export { SupplierReportScreen };
